<template>
    <div class="staoInfo">
        <router-view></router-view>
        <div class="infoHolder">
            <i id="closeInfo" class="material-icons" @click="closeInfo">close</i>
            <form class="staoInfoForm" autocomplete="off">
                <p>{{staoInfo.id}}</p>
                <input class="staoInfoInput" type="text" placeholder="stao name" v-model="staoInfo.name">
                diag:
                <select  v-model="staoInfo.diag">
                    <option value="0">
                        -
                    </option>
                    <option value="1">
                        diagnose
                    </option>
                </select>
                <div class="buttonHolder">
                    <button class="saveButton" @click.prevent="save">save</button>
                    <button class="delButton" @click.prevent="del">del</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
        }
    },
    computed: {
        staoInfo () {
            return this.$store.getters['user/staoInfo'];
        }
    },
    methods: {
        closeInfo () {
            this.$router.go(-1);
        },
        save () {
            this.$store.dispatch('user/saveStaoInfo', this.staoInfo);
        },
        del () {
            this.$router.push({ name: 'delstaoverify' });
        },
        changePW () {
            const data = { id: this.staoInfo.id };
            this.$store.dispatch('user/changePW', data);
        }
    },
    mounted () {
    }
}
</script>

<style scoped sass>
    #closeInfo {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        font-size: 40px;
    }

    .buttonHolder {
        display: flex;
        flex-direction: row;
    }

    .staoInfo {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        /*background-color: blue;*/
    }

    .infoHolder {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        /*height: 200px;*/
        background-color: white;
        box-shadow: 0px 0px 60px grey;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .staoInfoForm {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 20px;
        margin-right: 40px;
    }

    .staoInfoInput {
        font-size: 20px;

    }

    #inputStao {
        height: 50px;
        font-size: 25px;
    }

    #inputLagerCheff {
        height: 50px;
        font-size: 25px;
    }

    .saveButton {
        flex: 4;
        width: 100%;
        color: white;
        font-size: 20px;
        background-color: green;
    }

    .delButton {
        flex: 1;
        width: 100%;
        color: white;
        font-size: 20px;
        background-color: red;
        min-height: 40px;
    }

    @media screen and (min-width: 500px) {
        .infoHolder {
            width: 500px;
        }

    }

    @media screen and (min-width: 1300px) {
        .infoHolder {
            width: 600px;
        }

        .staoInfoInput {
            font-size: 30px;
        }

        .saveButton {
            font-size: 40px;
        }

        .delButton {
            font-size: 30px;
        }

    }

</style>
